import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, Image, PdfReference } from '../../types'
import { ColorContainerContentTextData } from '../color-container-content-text/color-container-content-text.component.converter'
import { CmsConverterService, defaultLinkData, defaultTextInput } from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class ColorContainerPdfTeaserConverter extends CmsConverterService<ColorContainerPdfTeaserData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    const altText = formData.st_alt_text?.value
    const title = formData.st_title_text?.value
    const lazyLoad = formData.st_lazy_load_image?.value
    return {
      contentText: {
        label: formData.st_label ?? defaultTextInput,
        headline: formData.st_headline ?? defaultTextInput,
        text: formData.st_text ?? defaultTextInput,
        textCentered: formData.st_centered_text?.value ?? false,
        spacing: {
          top: formData.st_spacing_bottom?.value?.identifier ?? '',
          bottom: formData.st_spacing_top?.value?.identifier ?? ''
        }
      } as ColorContainerContentTextData,
      image: CmsConverterService.mapImage(formData.st_image, lazyLoad, altText, title),
      pdfReference: formData.st_pdf_reference?.value?.[0]?.value?.target || defaultLinkData,
      captionBackgroundColor: formData.st_background_color_caption?.value?.identifier ?? 'bg-grey',
    }
  }
}

export const COLOR_CONTAINER_PDF_TEASER_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, ColorContainerPdfTeaserData>>('ColorContainerPdfTeaserConverter')

export interface ColorContainerPdfTeaserData extends ConvertedComponentData {
  contentText: ColorContainerContentTextData;
  image: Image;
  pdfReference: PdfReference;
  captionBackgroundColor: string;
}
